import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
//import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);

export default new Vuetify({
  //theme: { disable: true }
  theme: {
    light: {
      primary: "#0288D1",
      // secondary: colors.pink,
      accent: "#0288D1", //.v-application a など？
      // info: colors.lime,
      // success: colors.orange,
      // warning: colors.teal,
      //background: colors.black,
    },
    options: { customProperties: true },
  },
});
